import { Record as record } from 'immutable';

import { construct, fields, resolve } from '../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../helpers/Records';

import trainTime from '../../lib/TrainTime';
import Calculation from './itso/Calculation';

const fieldSchema = {
        refundId: [fields.number],
        initiatedBy: [fields.string],
        caseReference: [fields.string],
        reasonCode: [fields.number],
        otherReason: [fields.string],
        adminFee: [fields.number],
        created: [resolve.with(trainTime)],
        refundVia: [fields.string],
        calculation: [resolve.as(Calculation)],
};

class TicketRefundCalculation extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(TicketRefundCalculation, json, getResolvers(fieldSchema));
    }

    getRefundDate () {
        return this.created.format('DD MMMM YYYY');
    }
}

export default TicketRefundCalculation;



// WEBPACK FOOTER //
// ./src/records/refund/TicketRefundCalculation.js